import React, { useRef, useState } from "react";
import { Pause, Play, X } from "lucide-react";
import { API, SERIF } from "./practiceApi";

// Day 11: Adelaida's short halfway note (one shared recording). Stays until dismissed.
export const HalfwayNote = ({ onDismiss }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const toggle = () => { const a = ref.current; if (a.paused) a.play().catch(() => {}); else a.pause(); };
  return (
    <div className="relative rounded-2xl border border-[#d7bb7a]/40 bg-[#d7bb7a]/[0.07] p-4 pr-10 animate-in fade-in duration-500" data-testid="practice-halfway-note">
      <button type="button" onClick={onDismiss} aria-label="Dismiss" data-testid="practice-halfway-dismiss"
        className="absolute right-3 top-3 text-[#b9ad8f] transition-colors hover:text-[#f3ecd9]"><X size={16} /></button>
      <p className="text-[0.62rem] uppercase tracking-[0.28em] text-[#d7bb7a]">Halfway · a note from Adelaida</p>
      <div className="mt-3 flex items-center gap-3">
        <button type="button" onClick={toggle} aria-label={playing ? "Pause" : "Play"} data-testid="practice-halfway-play"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#d7bb7a] text-[#0b1a33] transition-opacity hover:opacity-90">
          {playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
        </button>
        <p className="text-base italic text-[#f3ecd9]" style={{ fontFamily: SERIF }}>You're halfway. Let your words settle a little deeper.</p>
      </div>
      <audio ref={ref} src={`${API}/api/practice/halfway-audio`} preload="none" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
    </div>
  );
};
